export default {
  namespaced: true,
  state: {
    deptId: '',
    vehicleName: '',
    keyword: ''
  },
  getters: {
    deptId: function deptId(state) {
      return state.deptId;
    },
    vehicleName: function vehicleName(state) {
      return state.vehicleName;
    },
    keyword: function keyword(state) {
      return state.vehicleName;
    }
  },
  mutations: {
    setDeptId: function setDeptId(state, deptId) {
      state.deptId = deptId;
    },
    setVehicleName: function setVehicleName(state, vehicleName) {
      state.vehicleName = vehicleName;
    },
    setKeyword: function setKeyword(state, keyword) {
      state.keyword = keyword;
    },
    clearSettleMent: function clearSettleMent(state) {
      state.deptId = [''];
      state.vehicleName = '';
      state.keyword = '';
    }
  }
};